"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProfileSaga = void 0;

var effects_1 = require("redux-saga/effects");

var dcl_catalyst_commons_1 = require("dcl-catalyst-commons");

var peer_1 = require("../../lib/peer");

var entities_1 = require("../../lib/entities");

var actions_1 = require("../wallet/actions");

var actions_2 = require("./actions");

function createProfileSaga(_ref) {
  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(profileSaga),
      _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(handleLoadProfileRequest),
      _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(handleWallet),
      _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(handleSetProfileDescription);

  var peerUrl = _ref.peerUrl;
  var peerApi = new peer_1.PeerAPI(peerUrl);
  var entities = new entities_1.EntitesOperator(peerUrl);

  function profileSaga() {
    return _regeneratorRuntime.wrap(function profileSaga$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return effects_1.takeEvery(actions_2.LOAD_PROFILE_REQUEST, handleLoadProfileRequest);

          case 2:
            _context.next = 4;
            return effects_1.takeEvery(actions_2.SET_PROFILE_AVATAR_DESCRIPTION_REQUEST, handleSetProfileDescription);

          case 4:
            _context.next = 6;
            return effects_1.takeLatest(actions_1.CONNECT_WALLET_SUCCESS, handleWallet);

          case 6:
            _context.next = 8;
            return effects_1.takeLatest(actions_1.CHANGE_ACCOUNT, handleWallet);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _marked);
  }

  function handleLoadProfileRequest(action) {
    var address, profile;
    return _regeneratorRuntime.wrap(function handleLoadProfileRequest$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            address = action.payload.address;
            _context2.prev = 1;
            _context2.next = 4;
            return effects_1.call([peerApi, 'fetchProfile'], address);

          case 4:
            profile = _context2.sent;
            _context2.next = 7;
            return effects_1.put(actions_2.loadProfileSuccess(address, profile));

          case 7:
            _context2.next = 13;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            _context2.next = 13;
            return effects_1.put(actions_2.loadProfileFailure(address, _context2.t0.message));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _marked2, null, [[1, 9]]);
  }

  function handleWallet(action) {
    return _regeneratorRuntime.wrap(function handleWallet$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return effects_1.put(actions_2.loadProfileRequest(action.payload.wallet.address));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _marked3);
  }
  /**
   * Handles the action to set the description of a user's profile.
   * This handler gets the first profile entity of a given address
   * and then rebuilds it with the specified description to deploy it
   * again.
   *
   * @param action - The action that triggered the handler.
   */


  function handleSetProfileDescription(action) {
    var _action$payload, address, description, entity, newAvatar, newEntity;

    return _regeneratorRuntime.wrap(function handleSetProfileDescription$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _action$payload = action.payload, address = _action$payload.address, description = _action$payload.description;
            _context4.next = 4;
            return effects_1.call([entities, 'getProfileEntity'], address);

          case 4:
            entity = _context4.sent;
            // Does a profile always have an avatar?
            newAvatar = Object.assign(Object.assign({}, entity.metadata.avatars[0]), {
              version: entity.metadata.avatars[0].version + 1,
              description: description
            });
            newEntity = Object.assign(Object.assign({}, entity), {
              metadata: Object.assign(Object.assign({}, entity.metadata), {
                avatars: [newAvatar].concat(_toConsumableArray(entity.metadata.avatars.slice(1)))
              })
            });
            _context4.next = 9;
            return effects_1.call([entities, 'deployEntityWithoutNewFiles'], newEntity, dcl_catalyst_commons_1.EntityType.PROFILE, action.payload.address);

          case 9:
            _context4.next = 11;
            return effects_1.put(actions_2.setProfileAvatarDescriptionSuccess(action.payload.address, newAvatar.description, newAvatar.version));

          case 11:
            _context4.next = 17;
            break;

          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](0);
            _context4.next = 17;
            return effects_1.put(actions_2.setProfileAvatarDescriptionFailure(action.payload.address, _context4.t0.message));

          case 17:
          case "end":
            return _context4.stop();
        }
      }
    }, _marked4, null, [[0, 13]]);
  }

  return profileSaga;
}

exports.createProfileSaga = createProfileSaga;